<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container child">
          <div class="modal-header">
            <h3>
              {{
                translation.id === null
                  ? 'Add Translation'
                  : 'Edit Translation'
              }}
            </h3>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <div
                :class="{ 'has-error': hasErrors }"
                class="col-sm-12">
                <label
                  class="col-sm-4 col-form-label"
                  for="label-name">Label</label>
                <input
                  id="label-name"
                  v-model="label.name"
                  name="label-name"
                  type="text"
                  readonly
                  class="form-control-sm col-sm-6 disabled">
              </div>
            </div>
            <div class="form-group row">
              <div
                :class="{ 'has-error': hasErrors }"
                class="col-sm-12">
                <label
                  class="col-sm-4 col-form-label"
                  for="language-name">Language</label>
                <input
                  id="language-name"
                  v-model="language.language"
                  name="language-name"
                  type="text"
                  readonly
                  class="form-control-sm col-sm-6 disabled">
              </div>
            </div>
            <div class="form-group row">
              <div
                :class="{ 'has-error': hasErrors }"
                class="col-xs-12">
                <label for="label_translation">Translation</label>
                <textarea
                  id="label_translation"
                  v-model="lTranslation"
                  :dir="isRTL"
                  name="label_translation"
                  rows="5"
                  style="resize: none;"
                  class="form-control"/>
              </div>
            </div>

            <div
              v-if="hasErrors"
              class="alert alert-danger"
              role="alert">
              <button
                type="button"
                class="close"
                @click="hasErrors = false">
                <span aria-hidden="true">×</span>
              </button>
              <p>
                <strong>Please fill in the mandatory
                fields.</strong>
              </p>
            </div>
          </div>

          <div class="modal-footer">
            <button
              v-if="userLoggedIn"
              type="submit"
              class="btn btn-sm btn-primary"
              @click="saveTranslation()">
              {{ translation.id === null ? 'Add' : 'Edit' }}
            </button>

            <button
              class="modal-default-button btn btn-sm btn-default"
              @click="$emit('close')">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '../services/eventBus.js';
import { mapGetters, } from 'vuex';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['label', 'language', 'translation',],
	data() {
		return {
			lTranslation: '',
			hasErrors: false,
		};
	},
	computed: {
    ...mapGetters(['userLoggedIn',]),
		isRTL() {
			return this.language.name.toLowerCase() === 'ar' ||
				this.language.name.toLowerCase() === 'hw'
				? 'RTL'
				: '';
		},
	},
	created() {
		this.lTranslation = this.translation.value;
	},
	methods: {
		saveTranslation() {
			let _self = this;
			_self.translation.label = {
				id: _self.label.id,
				name: _self.label.name,
			};
			// Let's validate
			if (_self.lTranslation !== '') {
				_self.hasErrors = false;
				_self.translation.value = _self.lTranslation;
				EventBus.$emit('saveTranslation', _self.translation);
			} else {
				_self.hasErrors = true;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalAddEditTranslation.vue